import { Badge, Image, video } from "@";

export const TablePreview = ({ row, setVideoPreview }) => {
  return (
    <>
      {row?.mediaType === 0 ? (
        <Image
          src={row?.fullUrl}
          className="cursor-pointer rounded-md ring-gray-200 hover:scale-110 hover:ring-purple-900"
        />
      ) : (
        <Image
          src={video}
          click={() => setVideoPreview(row?.fullUrl)}
          className="cursor-pointer rounded-md ring-gray-200 hover:scale-110 hover:ring-purple-900"
        />
      )}
    </>
  );
};

// Define table columns configuration
export const tableColumns = [
  {
    name: "العنوان",
    selector: ({ title }) => title,
    grow: 2,
  },

  {
    name: "الترتيب",
    selector: ({ order }) => order,
  },

  {
    name: "الحالة ",
    cell: ({ isActive }) => (
      <Badge
        title={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "green" : "red"}
      />
    ),
  },

  {
    name: "النوع",
    cell: ({ mediaType }) => (
      <Badge
        title={mediaType === 0 ? "صورة" : "فيديو"}
        color={mediaType === 0 ? "default" : "dark"}
      />
    ),
  },
];
